import { Outlet } from 'react-router-dom'

import { useUser } from '@/hooks/useUser'
import { useVcosole } from '@/hooks/useVconsole'

export default function RootLayout() {
  const [vc] = useVcosole()
  const navigate = useNavigate()
  const location = useLocation()
  const { isError } = useUser()
  useEffect(() => {
    console.log('VConsole ?', vc)
    if (vc) {
      vc.show()
    }
  }, [])

  useEffect(() => {
    const publicPaths = ['/', '/login']
    const isPublicPath = publicPaths.includes(location.pathname)

    if (isError && !isPublicPath) {
      // 用户未登录或 token 无效，重定向到登录页
      navigate('/login')
    }
  }, [isError, navigate, location])
  return <Outlet />
}
